import axios from 'axios'
import { BaseAIProvider, AIRequestPayload, AIResponse, AIConfig, AIProviderModel } from '../IAIProvider'

export class OllamaProvider extends BaseAIProvider {
  constructor(config: AIConfig, callbacks?: any) {
    super(config, callbacks)
  }

  async getAvailableModels(): Promise<AIProviderModel[]> {
    try {
      const res = await axios.get(`${this.config.baseUrl}/api/tags`)
      // 假设返回 { models: [{ name: 'llama2' }, ...] }
      return res.data.models.map((m: any) => ({
        name: m.name,
        raw: m
      }))
    } catch (error) {
      console.error('Failed to get Ollama models:', error)
      return []
    }
  }

  async sendRequest(payload: AIRequestPayload, customRequestId?: string): Promise<AIResponse> {
    const requestId = this.getOrGenerateRequestId(customRequestId)
    try {
      const controller = this.recordRequestStart(requestId, payload)
      if (!controller) {
        throw new Error('Failed to create abort controller')
      }
      const res = await axios.post(`${this.config.baseUrl}/api/generate`, payload, {
        signal: controller.signal
      })
      // 假设返回 { response: 'xxx' }
      const response: AIResponse = {
        text: res.data.response,
        requestId
      }

      this.recordRequestComplete(requestId, response)
      return response
    } catch (error) {
      if (error instanceof Error) {
        this.recordRequestError(requestId, error)
      }
      throw error
    }
  }

  async sendStreamingRequest(payload: AIRequestPayload, onData: (data: AIResponse) => void, customRequestId?: string): Promise<void> {
    const requestId = this.getOrGenerateRequestId(customRequestId)
    try {
      const controller = this.recordRequestStart(requestId, payload)
      if (!controller) {
        throw new Error('Failed to create abort controller')
      }

      const response = await fetch(`${this.config.baseUrl}/api/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, stream: true }),
        signal: controller.signal
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const reader = response.body?.getReader()
      if (!reader) {
        throw new Error('No response body reader available')
      }

      let decoder = new TextDecoder()
      let accumulatedText = ''

      while (true) {
        const { done, value } = await reader.read()
        if (done) break

        const chunk = decoder.decode(value)
        if (chunk.trim()) {
          accumulatedText += chunk
          onData({ text: chunk, requestId })
        }
      }

      // 流式请求完成
      const finalResponse: AIResponse = {
        text: accumulatedText,
        requestId
      }

      this.recordRequestComplete(requestId, finalResponse)
    } catch (error) {
      if (error instanceof Error) {
        this.recordRequestError(requestId, error)
      }
      throw error
    }
  }
} 